module.exports = __webpack_public_path__ + "static/media/right-arrow-sprite.58e5f14d.svg";